export default __webpack_public_path__ + "static/media/destino-arg-mb.9cde60e6.png";